module.exports = __webpack_public_path__ + "static/img/a4.e77bb77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a4.png
// module id = BQwe
// module chunks = 0